// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CopySvg from '@rsuite/icon-font/lib/action/Copy';
var Copy = createSvgIcon({
  as: CopySvg,
  ariaLabel: 'copy',
  category: 'action',
  displayName: 'Copy'
});
export default Copy;